// ========= Bracelet Configurator (Shopify) =========
// NB: Aucune requête Admin API côté front (sécurité).
//     Tout le groupement utilise 'bundle_id'.

if (document.readyState !== 'loading') initConfigurator();
else document.addEventListener('DOMContentLoaded', initConfigurator);

function initConfigurator() {
  const app = document.getElementById('bracelet-app');
  const rootSection = document.getElementById('bracelet-configurator');
  if (!app || !rootSection) return;

  // État
  let sequence = [];
  let currentEl = null;

  // ID variante du produit "Bracelet personnalisé"
  const braceletVariantId = parseInt(
    rootSection.dataset.braceletVariantId,
    10
  );

  // Eléments UI
  const form        = document.getElementById('bracelet-configurator-form');
  const wristInput  = app.querySelector('#wrist-size');
  const ctaBtn      = app.querySelector('#add-bracelet-bundle');
  const slotsCont   = app.querySelector('#slots-container');
  const slotsWrapper= app.querySelector('#slots-wrapper');

  // ---------- Rendu visuel ----------
  function renderSlotsFromSequence() {
    slotsWrapper.innerHTML = '';
    const diameterPx = slotsCont.offsetWidth || 300;
    const tourCm     = parseFloat(wristInput.value) || 0;
    const tourMm     = tourCm * 10;
    const sumMm      = sequence.reduce((s, b) => s + b.sizeMm, 0);
    const pxPerMm    = (Math.PI * diameterPx) / Math.max(tourMm, sumMm || tourMm);

    let angle = -Math.PI / 2;
    sequence.forEach(item => {
      const rawPx  = item.sizeMm * pxPerMm;
      const diamPx = Math.round(rawPx);
      angle += rawPx / diameterPx;

      const slot = document.createElement('div');
      slot.className = 'bracelet-slot';
      slot.style.cssText = `
        width:${diamPx}px;height:${diamPx}px;
        left:${Math.round(diameterPx/2 + Math.cos(angle)*(diameterPx/2) - diamPx/2)}px;
        top:${Math.round(diameterPx/2 + Math.sin(angle)*(diameterPx/2) - diamPx/2)}px;`;

      const img = document.createElement('img');
      img.src = item.imageSrc;
      img.alt = item.name;
      slot.appendChild(img);

      slot.addEventListener('click', () => {
        sequence = sequence.filter(b => b !== item);
        renderSlotsFromSequence();
      });

      slotsWrapper.appendChild(slot);
      angle += rawPx / diameterPx;
    });

    const sumCm = (sumMm / 10).toFixed(1);
    const totalCents = sequence.reduce((s, b) => s + b.unitPrice, 0);
    const totalStr   = (totalCents / 100).toLocaleString('fr-FR', { style:'currency', currency:'EUR' });

    slotsCont.classList.toggle('has-beads', sequence.length > 0);

    if (sequence.length && parseFloat(sumCm) >= tourCm) {
      ctaBtn.disabled = false;
      ctaBtn.classList.add('ready');
      ctaBtn.innerHTML = `Ajouter au panier — <span id="button-price">${totalStr}</span>`;
    } else {
      ctaBtn.disabled = true;
      ctaBtn.classList.remove('ready');
      ctaBtn.innerHTML = `<span>Termine ton bracelet</span><br><small>${sumCm} / ${tourCm.toFixed(1)} cm</small>`;
    }
  }

  // ---------- Ajouter une perle ----------
  function addToBracelet(name, id, priceCents, sizeMm, imageSrc) {
    sequence.push({ name, id, unitPrice: priceCents, sizeMm, imageSrc });
    renderSlotsFromSequence();
    document.querySelectorAll('.perle.selected').forEach(el => el.classList.remove('selected'));
    if (currentEl) currentEl.classList.add('selected');
  }

  // ---------- Click sur le carousel ----------
  const carousel = document.getElementById('carousel');
  if (carousel) {
    carousel.addEventListener('click', e => {
      const perleEl = e.target.closest('.perle');
      if (!perleEl) return;
      currentEl = perleEl;
      addToBracelet(
        perleEl.dataset.name,
        +perleEl.dataset.id,           // VARIANT ID
        +perleEl.dataset.price,        // en centimes
        +perleEl.dataset.size,         // diamètre mm
        perleEl.dataset.img
      );
    });
  }

  // ---------- Submit : envoi du bundle ----------
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!sequence.length) return;

    const bundleId = Math.random().toString(36).slice(2, 11);
    let imageURL = '';

    // 1) Capture visuelle (optionnelle)
    try {
      if (window.html2canvas) {
        ctaBtn.style.visibility = 'hidden';
        const canvas = await html2canvas(slotsCont, { backgroundColor: null, scale: 2 });
        ctaBtn.style.visibility = 'visible';
        imageURL = canvas.toDataURL('image/jpeg', 0.6);
      }
    } catch (err) {
      console.warn('html2canvas a échoué :', err);
    }

    // 2) Regrouper les perles identiques (même nom + taille)
    const beadDetails = sequence.reduce((arr, bead) => {
      const key = `${bead.name}|${bead.sizeMm}`;
      let entry = arr.find(x => x.key === key);
      if (entry) {
        entry.qty += 1;
      } else {
        arr.push({
          key,
          id: bead.id,                // VARIANT ID
          name: bead.name,
          size: bead.sizeMm,          // <- clé cohérente avec le rendu panier
          qty: 1,
          price_cents: bead.unitPrice // pour l'affichage récap
        });
      }
      return arr;
    }, []).map(x => { delete x.key; return x; });

    // 3) Ligne parent (bracelet)
    const parentItem = {
      id:       braceletVariantId,
      quantity: 1,
      properties: {
        bundle_id:            bundleId,
        item_type:            'bracelet',
        Vue:                  'Bracelet configuré',
        'Taille du bracelet': `${wristInput.value} cm`,
        custom_image_url:     imageURL,
        bead_details:         JSON.stringify(beadDetails)
      }
    };

    // 4) Enfants (perles) — chaque perle est un variant réel
    const childItems = beadDetails.map(perle => ({
      id:        perle.id,          // VARIANT ID perle
      quantity:  perle.qty,
      properties: {
        bundle_id:  bundleId,
        item_type:  'bead',
        'Pierre du bracelet': perle.name,
        'Taille':            `${perle.size} mm`
      }
    }));

    const itemsToAdd = [parentItem, ...childItems];
    // Debug éventuel :
    // console.log('ADD =>', itemsToAdd);

    // 5) Ajout au panier (batch)
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
      if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        throw new Error(err.description || `HTTP ${res.status}`);
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error('Erreur add-to-cart :', err);
      alert('Impossible d’ajouter le bracelet. Merci de réessayer.');
    }
  });

  // ---------- Réactivité taille de poignet ----------
  wristInput.addEventListener('input', renderSlotsFromSequence);
  renderSlotsFromSequence();
}


// ========= PANIER – Rendu résumé des perles (depuis bead_details JSON) =========
// À utiliser sur la page /cart, après le HTML de la section panier.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bead-details-container:not(.beads-init)').forEach(container => {
    const raw = container.dataset.beads || '';
    let beads = [];
    try {
      // Données JSON provenant de item.properties.bead_details
      if (raw && (raw.trim().startsWith('[') || raw.trim().startsWith('{'))) {
        beads = JSON.parse(raw);
      }
    } catch (e) {
      console.warn('Erreur JSON bead_details:', e, raw);
    }
    container.classList.add('beads-init');

    if (!Array.isArray(beads) || beads.length === 0) {
      container.innerHTML = '<em style="color:#999; font-size: 0.9em;">(Aucun détail disponible)</em>';
      return;
    }

    const wrap = document.createElement('div');
    wrap.className = 'bracelet-card';

    beads.forEach(b => {
      const qty  = Number(b.qty || 1);
      const unit = Number(b.price_cents || 0) / 100;
      const total= unit * qty;

      const line = document.createElement('div');
      line.className = 'bracelet-line';
      line.innerHTML = `
        <div class="stone-name">${b.name}</div>
        <div class="stone-details">
          <span>${b.size} mm</span>
          <span>× ${qty}</span>
          <span>${unit.toFixed(2)} €</span>
          <span class="total">${total.toFixed(2)} €</span>
        </div>
      `;
      wrap.appendChild(line);
    });

    container.innerHTML = '';
    container.appendChild(wrap);
  });
});
